var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLamp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-8 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 12px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke: #00abe9;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-6, .cls-7 {\n        stroke-width: 35px;\n      }\n\n      .cls-2, .cls-3, .cls-6, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9 {\n        fill: #8cc63f;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-18 {\n        fill: #3fa9f5;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n\n      .cls-19 {\n        fill: #5f6368;\n      }\n\n      .cls-5 {\n        stroke-width: 14px;\n      }\n\n      .cls-20 {\n        fill: #00abe9;\n      }\n\n      .cls-21 {\n        fill: #00abe9;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 14.02 46.72;\n      }\n\n      .cls-22 {\n        fill: #f8bb3d;\n      }\n\n      .cls-23 {\n        fill: #009fe3;\n      }\n\n      .cls-24 {\n        fill: #bdccd4;\n      }\n\n      .cls-25 {\n        display: none;\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-7 {\n        stroke-dasharray: 0 60;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1688.85,457.97l-43.12,21.76-371.06,181.4v150.91l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1732.81,508.57l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1274.67,
    y: 204.06,
    width: 759.42,
    height: 983.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1798.97-282.89l-43.12,21.76-371.06,181.4V71.18l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1842.93-232.29l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1384.79,
    y: -536.8,
    width: 759.42,
    height: 983.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1781.47-985.01l-46.46,23.44-399.78,195.44v162.59l378.07-307.06,76.51-61.45c3.08-2.49,3.81-6.91,1.66-10.24-1.46-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1828.83-930.49l-51.91,46.29-441.69,392.72V-199.25l447.59-642.16,57.43-78.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1335.23,
    y: -1258.57,
    width: 818.2,
    height: 1059.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_4",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oMHC52.tif"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Layer_0",
    width: 258,
    height: 261,
    transform: "translate(-12.98 -21) scale(2.07)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    width: 500,
    height: 500,
    rx: 15.5,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.39,
    y: 188.74,
    width: 351.15,
    height: 99.5,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-99.53 236.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.26,376.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.42,358.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 153.25,
    y1: 324.78,
    x2: 183.87,
    y2: 355.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 195.5,
    y1: 282.53,
    x2: 226.12,
    y2: 313.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M289.5,249.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.72,238.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 280,
    y1: 198.03,
    x2: 310.62,
    y2: 228.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 322.25,
    y1: 155.78,
    x2: 352.88,
    y2: 186.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.99,334.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.21,323.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 220.24,
    y1: 224.21,
    x2: 267.89,
    y2: 270.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M352.29,294.4s54.41-54.4,81.49-81.62c6.17-6.2,12.99-10.64,22.13-10.51,18.88.27,30.91,21.16,21.36,37.44-1.87,3.18-4.35,6.11-6.97,8.73-58.39,58.56-116.78,117.12-175.31,175.54-24.31,24.26-52.14,42.81-86.43,49.58-46.13,9.11-87.67-2.46-123.84-31.36-39.93-31.92-64.14-72.92-64.17-125.49-.02-34.14,13.08-63.82,33.7-90.39,6.29-8.11,13.27-15.77,20.51-23.07,31.82-32.12,56.63-54.41,88.13-86.84,11.26-11.59,28.29-11.64,37.96-1.36,10.14,10.78,9.46,25.72-2.28,37.49-19.68,19.75-60.59,58.47-80.29,78.2l-2.3,2.3c-2.19,2.2-2.23,5.75-.07,7.98,20.66,21.27,41.96,41.81,45.58,71.76,2.85,23.61-6.36,45.61-26.05,67.49-2.13,2.37-2.06,5.98.19,8.24l1.32,1.32c2.1,2.1,5.53,2.07,7.6-.07,20.88-21.63,30.87-40.67,30.12-69.79-1-38.68-19.21-54.46-38.83-76.26-2.79-3.1-2.69-7.84.25-10.8l.32-.34c54.36-54.64,137.11-137.29,191.49-191.9,1.82-1.82,3.65-3.65,5.63-5.29,10.88-8.98,25.59-8.34,34.9,1.45,9.45,9.94,9.55,24.39.22,34.96-1.39,1.58-2.95,3.02-4.44,4.51-38.22,38.27-76.45,76.54-114.67,114.82l-3.46,3.79s-3.09,2.51-.58,5.59l5.16,4.77s2.65,1.69,5.74-.82l3.97-3.49c46.67-46.73,93.27-93.52,140.1-140.08,4.18-4.16,9.45-7.88,14.91-9.97,10.39-3.99,21.96.71,28.21,10.12,6.13,9.22,5.37,21.52-1.93,29.99-1.83,2.13-3.85,4.09-5.84,6.08-46.66,46.73-86.38,86.49-133.03,133.21l-4.24,3.95s-3.86,3.13-.33,7.77l2.51,3.09s3.37,3.85,8,.09l4.5-4.18s75.8-75.94,117.21-117.35c11.26-11.26,25.71-12.91,35.88-4.25,12.34,10.5,13.11,26.64,1.82,38.31-1.79,1.85-3.63,3.66-5.45,5.48-40.23,40.28-80.46,80.56-120.68,120.84l-3.76,3.77s-4.77,5.16-2.26,8.25l3.76,4.63s2.51,3.09,7.14-.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.18,
    y: 182.99,
    width: 470.53,
    height: 133.33,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-103.18 250.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.69,433.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.78,410.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 139.61,
    y1: 365.28,
    x2: 180.64,
    y2: 406.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 196.23,
    y1: 308.66,
    x2: 237.26,
    y2: 349.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.18,264.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.74,250.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 309.46,
    y1: 195.43,
    x2: 350.49,
    y2: 236.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 366.07,
    y1: 138.82,
    x2: 407.11,
    y2: 179.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.95,378"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.51,363.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 229.38,
    y1: 230.51,
    x2: 293.23,
    y2: 292.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M243.67,26.89l-62.48,108.22c-4.59,7.95,1.15,17.89,10.33,17.89h124.96c9.18,0,14.92-9.94,10.33-17.89l-62.48-108.22c-4.59-7.95-16.07-7.95-20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.78,239.67l-108.22-62.48c-7.95-4.59-17.89,1.15-17.89,10.33v124.96c0,9.18,9.94,14.92,17.89,10.33l108.22-62.48c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264,473.68l62.48-108.22c4.59-7.95-1.15-17.89-10.33-17.89h-124.96c-9.18,0-14.92,9.94-10.33,17.89l62.48,108.22c4.59,7.95,16.07,7.95,20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M26.56,260.33l108.22,62.48c7.95,4.59,17.89-1.15,17.89-10.33v-124.96c0-9.18-9.94-14.92-17.89-10.33l-108.22,62.48c-7.95,4.59-7.95,16.07,0,20.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 278.83,
    cy: 257.88,
    r: 49.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M205.03,112.86l-28.55,31.2h-60.46c-17.16,0-31.2,14.04-31.2,31.2v167.22c0,17.16,14.04,31.2,31.2,31.2h260.62c17.16,0,31.2-14.04,31.2-31.2v-167.22c0-17.16-14.04-31.2-31.2-31.2h-49.46l-28.55-31.2h-93.61ZM279.02,356.46c-54.55,0-98.82-44.27-98.82-98.82s44.27-98.82,98.82-98.82,98.82,44.27,98.82,98.82-44.27,98.82-98.82,98.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136,37.5h-66s-32.5-1-32.5,32.5v61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.98,462.36h66s32.5,1,32.5-32.5v-61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.15,135.87v-66s1-32.5-32.5-32.5h-61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.3,363.85v66s-1,32.5,32.5,32.5h61.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_9",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.73,
    y1: 361.07,
    x2: 375.27,
    y2: 361.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 181.33,
    y1: 415.35,
    x2: 318.67,
    y2: 415.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.5,
    y1: 306.05,
    x2: 427.5,
    y2: 306.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.92,
    y1: 250,
    x2: 44.42,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 91.14,
    y1: 250,
    x2: 432.22,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 455.58,
    y1: 250,
    x2: 463.08,
    y2: 250
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(-2098.09 -894.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "v")), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249,49c-78.92,0-142.95,63.71-143.49,142.5h286.97c-.54-78.79-64.57-142.5-143.49-142.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M239.67,71.38l-62.48,108.22c-4.59,7.95,1.15,17.89,10.33,17.89h124.96c9.18,0,14.92-9.94,10.33-17.89l-62.48-108.22c-4.59-7.95-16.07-7.95-20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M260.33,428.61l62.48-108.22c4.59-7.95-1.15-17.89-10.33-17.89h-124.96c-9.18,0-14.92,9.94-10.33,17.89l62.48,108.22c4.59,7.95,16.07,7.95,20.66,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.25,
    y1: 250,
    x2: 414.75,
    y2: 250
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_12",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 163.61,
    y1: 334.75,
    x2: 370,
    y2: 128.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 398.17,
    cy: 106.63,
    r: 43.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 99.9,
    cy: 394.75,
    r: 43.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1012.22,525.82l-271.02-156.47c-7.95-4.59-17.89,1.15-17.89,10.33v312.95c0,9.18,9.94,14.92,17.89,10.33l271.02-156.47c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M754.74-146.56h45.32v-55.15c0-14.16-11.48-25.65-25.65-25.65h-75.14v-39.44c0-9.18-9.94-14.92-17.89-10.33l-188.69,108.94c-7.95,4.59-7.95,16.07,0,20.66l188.69,108.94c7.95,4.59,17.89-1.15,17.89-10.33v-39.44h29.82v-32.56c0-14.16,11.48-25.65,25.65-25.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1036.46-87.38l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33v39.44h-29.82v32.56c0,14.16-11.48,25.65-25.65,25.65h-45.32v55.15c0,14.16,11.48,25.65,25.65,25.65h75.14V31.88c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M878.7,347.48l188.69,108.94c7.95,4.59,17.89-1.15,17.89-10.33v-217.88c0-9.18-9.94-14.92-17.89-10.33l-188.69,108.94c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1017.07,
    y: 267.65,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1444.52,258.67l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33v217.88c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1137.15,
    y: 199.5,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(2443.31 538) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M229.95,258.13v-35.92s-41.21-.01-41.21-.01v-31.34c.01-7.3-7.88-11.86-14.2-8.21L24.57,269.16c-6.32,3.65-6.32,12.76,0,16.41l149.91,86.62c6.32,3.65,14.22-.91,14.22-8.2v-31.34s59.72.02,59.72.02c11.26,0,20.38-9.12,20.39-20.37v-33.78s-18.48,0-18.48,0c-11.25,0-20.38-9.13-20.37-20.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M474.2,215.16l-149.91-86.62c-6.32-3.65-14.22.91-14.22,8.2v31.34s-59.72-.02-59.72-.02c-11.25,0-20.38,9.12-20.39,20.37v33.78s18.48,0,18.48,0c11.25,0,20.38,9.13,20.37,20.39v35.92s41.21.01,41.21.01v31.34c-.01,7.3,7.88,11.86,14.2,8.21l149.97-86.52c6.32-3.65,6.32-12.76,0-16.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_14",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1012.52-2.64c-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98-18.88-84.73-85.4-151.26-170.14-170.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M962.66,402.62c-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27s-81.6,178.78-180.14,180.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M645.92,78.42h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M732.19-73.06h0c0,18.42-14.94,33.36-33.36,33.36h-133.43c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36h133.43c18.42,0,33.36,14.94,33.36,33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M855.29-265.2h-33.36v-33.36c0-18.42-14.94-33.36-33.36-33.36h0c-18.42,0-33.36,14.94-33.36,33.36v33.36h-33.36c-18.42,0-33.36,14.94-33.36,33.36h0c0,18.42,14.94,33.36,33.36,33.36h33.36v33.36c0,18.42,14.94,33.36,33.36,33.36h0c18.42,0,33.36-14.94,33.36-33.36v-33.36h33.36c18.42,0,33.36-14.93,33.36-33.36h0c0-18.42-14.94-33.36-33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M722.56,155.06h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1508,1018.76h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM1508,1108.38h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1730.56,1114.58c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM1690.7,1169.56c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1632.57,972.51h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1709.22,1049.15h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1491.57,514.91h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM1491.57,604.53h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1714.13,610.73c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM1674.28,665.72c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1636.14,468.66h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1712.79,545.31h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2030.41,515.3h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM2030.41,604.92h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2252.97,611.12c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM2213.11,666.1c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2228.08,512.34h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2176.98,469.05c18.42,0,33.36,11.44,33.36,25.55v17.74h17.74c14.11,0,25.55,14.93,25.55,33.36h0c0,18.42-11.44,33.36-25.55,33.36h-17.74v17.74c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-17.74h-17.74c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h17.74v-17.74c0-14.11,14.94-25.55,33.36-25.55h0M2176.98,434.05c-16.56,0-32.5,5.22-44.87,14.7-10.57,8.1-17.95,18.85-21.36,30.72-11.87,3.41-22.62,10.78-30.72,21.36-9.48,12.37-14.7,28.31-14.7,44.87s5.22,32.5,14.7,44.87c8.1,10.57,18.85,17.95,30.72,21.36,3.41,11.87,10.78,22.62,21.36,30.72,12.37,9.48,28.31,14.7,44.87,14.7s32.5-5.22,44.87-14.7c10.57-8.1,17.95-18.85,21.36-30.72,11.87-3.41,22.62-10.78,30.72-21.36,9.48-12.37,14.7-28.31,14.7-44.87s-5.22-32.5-14.7-44.87c-8.1-10.57-18.85-17.95-30.72-21.36-3.41-11.87-10.78-22.62-21.36-30.72-12.37-9.48-28.31-14.7-44.87-14.7h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2578.58,511.03h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM2578.58,600.65h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2637.88,486.45c-19.37-6.67-40.2-10.18-61.87-9.88-98.54,1.36-178.78,81.6-180.14,180.14-1.42,102.75,82.52,186.68,185.27,185.27,98.54-1.36,178.78-81.6,180.14-180.14.08-5.89-.13-11.72-.6-17.48,0,0,28.32-2.36,39.82-40.22.21.9.43,1.81.63,2.71,37.13,166.63-108.34,312.1-274.98,274.98-84.73-18.88-151.26-85.4-170.14-170.14-37.13-166.63,108.34-312.1,274.98-274.98,14.7,3.27,28.85,7.99,42.3,13.98,0,0-24.3,10.31-35.41,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2776.25,508.07h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M250,101.76h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM250,191.38h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M309.3,77.18c-19.37-6.67-40.2-10.18-61.87-9.88-98.54,1.36-178.78,81.6-180.14,180.14-1.42,102.75,82.52,186.68,185.27,185.27,98.54-1.36,178.78-81.6,180.14-180.14.08-5.89-.13-11.72-.6-17.48,0,0,28.32-2.36,39.82-40.22.21.9.43,1.81.63,2.71,37.13,166.63-108.34,312.1-274.98,274.98-84.73-18.88-151.26-85.4-170.14-170.14C-9.68,135.78,135.78-9.68,302.42,27.44c14.7,3.27,28.85,7.99,42.3,13.98,0,0-24.3,10.31-35.41,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M447.67,98.8h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_15",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 629.86,
    y: -192.94,
    width: 459.24,
    height: 290.55,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(907.15 811.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1081.91-56.36l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33V62.9c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 774.55,
    y: -115.54,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(1718.09 -92.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M876.85,564.48v-39.44s-75.14,0-75.14,0c-14.16,0-25.65-11.48-25.65-25.65v-87.71c0-14.16,11.48-25.65,25.65-25.65h75.14s0-39.44,0-39.44c0-9.18,9.94-14.92,17.89-10.33l111.54,64.4v-150.74c0-14.16-11.48-25.65-25.65-25.65h-239.26c-14.16,0-25.65,11.48-25.65,25.64v407.95c0,14.16,11.48,25.65,25.64,25.65h239.26c14.16,0,25.65-11.48,25.65-25.64v-147.47s-111.54,64.4-111.54,64.4c-7.95,4.59-17.89-1.15-17.89-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1083.43,445.22l-77.15-44.54v109.74s77.15-44.54,77.15-44.54c7.95-4.59,7.95-16.07,0-20.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1688.85,457.97l-43.12,21.76-371.06,181.4v150.91l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1210.4,
    y: 362.22,
    width: 554.01,
    height: 544.79,
    transform: "translate(-62.38 1096.45) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1732.81,508.57l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1111.62,
    y: 434.81,
    width: 797.02,
    height: 824.4,
    transform: "translate(-192.81 1159.94) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1714.29,480.27l-108.15,83.31-331.47,249.13v107.41l375.72-360.5,73.21-68.39c2.79-2.63,3.06-6.99.57-9.91-1.42-1.67-3.45-2.54-5.49-2.54-1.53,0-3.08.49-4.39,1.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1762.5,443.42l28.15,31.22,177.56-159.89c14.5-13.12,17.04-18.31,21.17-26.99,3.17-6.56,7.09-14.82,16.61-28.36,17.24-24.34,10.16-35.87,10.05-35.98l-.74-.74c-3.06-2.33-15.24-5.71-36.72,6.35-14.39,8.04-22.96,11.12-29.94,13.55-9.1,3.17-14.6,5.19-29.1,18.2l-177.46,159.9,20.42,22.75ZM1789.38,497.71l-51.43-57.04-19.05-21.17,189.85-170.9c16.93-15.24,24.34-17.88,34.6-21.48,6.67-2.33,14.18-5.08,27.41-12.38,33.12-18.63,52.27-8.47,57.35-2.54,5.5,5.82,13.33,25.6-8.68,56.61-8.78,12.38-12.17,19.58-15.24,25.93-4.65,9.83-8.04,16.93-24.97,32.17l-189.85,170.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1984.73,254.11c-.53-.95-1.37-1.91-2.33-2.65-7.4-5.71-19.89-8.57-32.91.11l-6.88,4.65,33.22,36.83,5.3-6.35c9.95-11.96,8.47-24.66,3.6-32.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1696.9,391.78l23.49,26.14,123.38-111.85-39.47,2.96-107.41,82.75ZM1719.22,441.09l-46.35-51.43,125.4-96.51,91.95-6.98-171,154.92ZM1791.29,496.44l23.49,26.14,93.55-98.2,7.09-38.94-124.12,111ZM1814.46,546.6l-46.35-51.43,171.95-153.87-16.61,90.69-109,114.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1832.45 448.29 1773.19 382.47 1732.13 419.5 1791.18 485.12 1832.45 448.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1743.67,420.14l48.14,53.44,29.1-25.93-48.25-53.66-28.99,26.14ZM1790.54,496.65l-69.95-77.67,53.23-47.94,70.16,77.99-53.44,47.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1798.97-282.89l-43.12,21.76-371.06,181.4V71.18l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1320.51,
    y: -378.64,
    width: 554.01,
    height: 544.79,
    transform: "translate(436.25 995.94) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1842.93-232.29l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1221.73,
    y: -306.04,
    width: 797.02,
    height: 824.4,
    transform: "translate(305.82 1059.44) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1824.41-260.58l-108.15,83.31-331.47,249.13v107.41l375.72-360.5,73.21-68.39c2.79-2.63,3.06-6.99.57-9.91-1.42-1.67-3.45-2.54-5.49-2.54-1.53,0-3.08.49-4.39,1.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2094.84-486.75c-.53-.95-1.37-1.91-2.33-2.65-7.4-5.71-19.89-8.57-32.91.11l-6.88,4.65,33.22,36.83,5.3-6.35c9.95-11.96,8.47-24.66,3.6-32.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2138.23-528.65c-5.08-5.93-24.23-16.09-57.35,2.54-13.23,7.3-20.74,10.05-27.41,12.38-10.26,3.6-17.67,6.24-34.6,21.48l-43.87,39.5-66.6,5.05-125.4,96.51,46.35,51.43,10.53-9.54,8.21,9.12,40.66,45.1-10.5,9.4,46.35,51.43,108.99-114.61,12.04-65.74,43.73-39.34c16.93-15.24,20.32-22.33,24.97-32.17,3.06-6.35,6.45-13.55,15.24-25.93,22.01-31.01,14.18-50.79,8.68-56.61ZM1914.42-431.83l39.47-2.96-123.38,111.85-23.49-26.14,107.41-82.75ZM2018.44-316.49l-93.55,98.2-23.49-26.14,124.12-111-7.09,38.94ZM2116.11-481.46c-9.53,13.54-13.44,21.8-16.61,28.36-4.13,8.68-6.67,13.86-21.17,26.99l-135.38,121.9-48.57-53.99,135.27-121.88c14.5-13.01,20-15.03,29.1-18.2,6.98-2.43,15.55-5.5,29.94-13.55,21.48-12.06,33.66-8.68,36.72-6.35l.74.74c.11.11,7.19,11.64-10.05,35.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M471.78,42.83c-6.45-7.53-30.77-20.43-72.84,3.23-16.8,9.27-26.34,12.76-34.81,15.73-13.03,4.57-22.44,7.92-43.94,27.27l-55.72,50.16-84.59,6.42L20.62,268.21l58.86,65.31,13.37-12.11,10.42,11.58,51.64,57.28-13.34,11.94,58.86,65.31,138.43-145.56,15.29-83.49,55.54-49.96c21.5-19.35,25.8-28.36,31.72-40.85,3.89-8.07,8.2-17.21,19.35-32.93,27.95-39.38,18.01-64.51,11.02-71.9ZM187.54,165.8l50.13-3.76-156.7,142.06-29.83-33.2,136.41-105.1ZM319.65,312.29l-118.81,124.72-29.83-33.2,157.64-140.98-9,49.45ZM443.7,102.77c-12.1,17.2-17.07,27.69-21.1,36.02-5.24,11.02-8.47,17.61-26.88,34.27l-171.93,154.82-61.69-68.57,171.8-154.79c18.41-16.53,25.4-19.09,36.96-23.12,8.86-3.09,19.75-6.99,38.03-17.21,27.28-15.31,42.74-11.02,46.64-8.06l.94.94c.14.14,9.14,14.78-12.76,45.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1781.47-985.01l-46.46,23.44-399.78,195.44v162.59l378.07-307.06,76.51-61.45c3.08-2.49,3.81-6.91,1.66-10.24-1.46-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1265.98,
    y: -1088.17,
    width: 596.89,
    height: 586.95,
    transform: "translate(868.38 816.05) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1828.83-930.49l-51.91,46.29-441.69,392.72V-199.25l447.59-642.16,57.43-78.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1159.55,
    y: -1009.96,
    width: 858.71,
    height: 888.21,
    transform: "translate(727.85 884.46) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1808.88-960.98l-116.52,89.76-357.13,268.42v115.72l404.8-388.41,78.88-73.68c3.01-2.83,3.29-7.53.61-10.68-1.53-1.8-3.71-2.74-5.91-2.74-1.65,0-3.32.53-4.73,1.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2100.24-1204.65c-.57-1.02-1.48-2.05-2.51-2.85-7.98-6.15-21.43-9.23-35.45.12l-7.41,5.02,35.8,39.68,5.7-6.84c10.72-12.88,9.12-26.56,3.88-35.11"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2146.99-1249.79c-5.47-6.39-26.11-17.33-61.79,2.74-14.25,7.87-22.35,10.83-29.53,13.34-11.05,3.88-19.04,6.72-37.28,23.14l-47.27,42.55-71.76,5.45-135.1,103.98,49.93,55.41,11.34-10.28,8.84,9.82,43.81,48.59-11.32,10.13,49.93,55.41,117.43-123.48,12.97-70.82,47.11-42.39c18.24-16.42,21.89-24.06,26.9-34.66,3.3-6.84,6.95-14.6,16.42-27.94,23.71-33.41,15.28-54.72,9.35-60.99ZM1905.85-1145.47l42.52-3.19-132.93,120.51-25.31-28.16,115.72-89.15ZM2017.93-1021.21l-100.79,105.8-25.31-28.16,133.73-119.59-7.64,41.95ZM2123.16-1198.95c-10.26,14.59-14.48,23.49-17.9,30.56-4.45,9.35-7.19,14.94-22.8,29.07l-145.85,131.33-52.33-58.17,145.74-131.31c15.62-14.02,21.55-16.19,31.35-19.61,7.52-2.62,16.76-5.93,32.26-14.6,23.15-12.99,36.26-9.35,39.56-6.84l.8.8c.12.12,7.75,12.54-10.83,38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M412.11,137.44c12.64-15.19,10.75-31.31,4.57-41.39-.68-1.21-1.75-2.42-2.96-3.36-9.4-7.25-25.26-10.88-41.79.14l-8.74,5.91,42.2,46.77,6.72-8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1174.81-872.39c-5.47-6.39-26.11-17.33-61.79,2.74-14.25,7.87-22.35,10.83-29.53,13.34-11.05,3.88-19.04,6.72-37.28,23.14l-47.27,42.55-71.76,5.45-135.1,103.98,49.93,55.41,11.34-10.28,8.84,9.82,43.81,48.59-11.32,10.13,49.93,55.41,117.43-123.48,12.97-70.82,47.11-42.39c18.24-16.42,21.89-24.06,26.9-34.66,3.3-6.84,6.95-14.6,16.42-27.94,23.71-33.41,15.28-54.72,9.35-60.99ZM933.67-768.07l42.52-3.19-132.93,120.51-25.31-28.16,115.72-89.15ZM1045.75-643.8l-100.79,105.8-25.31-28.16,133.73-119.59-7.64,41.95ZM1150.98-821.54c-10.26,14.59-14.48,23.49-17.9,30.56-4.45,9.35-7.19,14.94-22.8,29.07l-145.85,131.33-52.33-58.17,145.74-131.31c15.62-14.02,21.55-16.19,31.35-19.61,7.52-2.62,16.76-5.93,32.26-14.6,23.15-12.99,36.26-9.35,39.56-6.84l.8.8c.12.12,7.75,12.54-10.83,38.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -434.83,
    x2: 701.93,
    y2: -480.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -415.38,
    x2: 701.93,
    y2: -434.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -480.1,
    x2: 701.93,
    y2: -501.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M846.73-571.77c3.01-2.83,3.29-7.53.61-10.68-1.53-1.8-3.71-2.74-5.91-2.74-1.65,0-3.32.53-4.73,1.61l-116.52,89.76-18.25,13.72v45.26l65.92-63.25,78.88-73.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M817.64-594.64c3.09-2.49,3.81-6.91,1.66-10.24-1.47-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84l-46.46,23.44-60.9,29.77v53.03l39.19-31.83,76.51-61.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M868.07-542.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96l-51.91,46.29-102.81,91.41v14.14h64.97l43.74-62.75,57.43-78.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1124.19-792.13c10.72-12.88,9.12-26.56,3.88-35.11-.57-1.02-1.48-2.05-2.51-2.85-7.98-6.15-21.43-9.23-35.45.12l-7.41,5.02,35.8,39.68,5.7-6.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227.05,
    y: 399.16,
    width: 45.89,
    height: 68.84,
    rx: 22.95,
    ry: 22.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.53,
    y: 215.58,
    width: 68.84,
    height: 45.89,
    rx: 22.95,
    ry: 22.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.63,
    y: 215.58,
    width: 68.84,
    height: 45.89,
    rx: 22.95,
    ry: 22.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.01,
    y: 345.43,
    width: 45.66,
    height: 68.84,
    rx: 22.83,
    ry: 22.83,
    transform: "translate(-157.34 379.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.89,
    y: 356.85,
    width: 68.84,
    height: 45.66,
    rx: 22.83,
    ry: 22.83,
    transform: "translate(-233.24 196.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.84,147.2V51.56c0-10.8-8.76-19.56-19.56-19.56h-98.56c-10.8,0-19.56,8.76-19.56,19.56v95.63c-27.4,20.83-45.42,53.06-45.89,89.86-.8,62.79,49.77,115.02,112.55,116.19,64.33,1.2,116.92-50.66,116.92-114.72,0-37.4-18.13-70.22-45.89-91.33ZM246.87,77.89h6.26c10.94,0,19.82,8.87,19.82,19.82v28.37c-7.34-1.38-15.15-2.29-22.95-2.29s-15.6.92-22.95,2.29v-28.37c0-10.94,8.87-19.82,19.82-19.82Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLamp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp.df923ffa0316f995571d087e2638dbc5.svg";